import { useThemeChildren } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';

import { useTheme } from './useThemeOverview';

export const useThemeCompanyCount = (themeId: string) => {
  const { data: theme } = useTheme({ themeId });
  const { data: children } = useThemeChildren(theme?.parent_theme.id ?? '');

  return children?.find(child => child.theme.id === themeId)?.company_count;
};
